import React from "react";
import { Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
import MicIcon from "@mui/icons-material/Mic";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Zoom from "react-medium-image-zoom";
import Switch from "@mui/material/Switch";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const label = { inputProps: { "aria-label": "Size switch demo" } };

// For Modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import DialogTitle from "@mui/material/DialogTitle";
// import CloseIcon from "@mui/icons-material/Close";
// End

function AgenciesNewList() {
  const navigate = useNavigate();

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // End

  return (
    <>
      <Grid container spacing={3} className="mainHeadingLine">
        <Grid item xs={12} md={12}>
          <div className="residentManagementTable">
            <div className="visitorListNewOut">
              <div className="visitorHead">Agencies List</div>
              <div className="visitorListNewInner">
                <div className="visitorSearch">
                  <div className="visitorSearchDiv">
                    <SearchIcon className="visitorSearchIco" />
                    <input type="text" placeholder="Search" />
                    <MicIcon className="visitorMicIco" />
                  </div>
                  <SortIcon
                    className="visitorFilterIco"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  />
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={handleClose}>Filter Item 1</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 2</MenuItem>
                    <MenuItem onClick={handleClose}>Filter Item 3</MenuItem>
                  </Menu>
                </div>

                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://i.pinimg.com/736x/cb/90/1c/cb901c6392512c9186cd55caf5e00d5f.jpg" alt="altimg"/>
                      </Zoom>
                    </div>
                    <div className="visitContLeft">
                      <h3 className="visitContHed">Company Name</h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">sara.cruz@example.com</p>
                    </div>
                    <div className="visitBottCont">
                      <p>Website</p>
                      <b>http://www.codehow.com</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Licence Number</p>
                      <b>256463</b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon
                        className="editBt"
                        // onClick={handleClickOpen2("body")}
                        onClick={() => navigate("/EditAgency")}
                      />
                      <DeleteIcon className="deleteBt" />
                      <Switch {...label} defaultChecked size="small" />
                    </div>
                  </div>
                </div>
                <div className="visitContDiv">
                  <div className="visitCont1 resideNewContOut">
                    <div className="visitContProf">
                      <Zoom>
                        <img src="https://i.pinimg.com/736x/cb/90/1c/cb901c6392512c9186cd55caf5e00d5f.jpg" alt="altimg" />
                      </Zoom>
                    </div>
                    <div className="visitContLeft">
                      <h3 className="visitContHed">Company Name</h3>
                      <p className="visitContMob">(704) 555-0127</p>
                      <p className="visitContTime">sara.cruz@example.com</p>
                    </div>
                    <div className="visitBottCont">
                      <p>Website</p>
                      <b>http://www.codehow.com</b>
                    </div>
                    <div className="visitBottCont">
                      <p>Licence Number</p>
                      <b>256463</b>
                    </div>
                    <div className="resideNewCont">
                      <CreateIcon
                        className="editBt"
                        // onClick={handleClickOpen2("body")}
                        onClick={() => navigate("/EditAgency")}
                      />
                      <DeleteIcon className="deleteBt" />
                      <Switch {...label} defaultChecked size="small" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* <div className="modalMain">
        <Dialog
          open={open2}
          onClose={handleClose2}
          scroll={scroll2}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Edit Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose2} />
          </DialogTitle>
          <DialogContent dividers={scroll2 === "paper"}>
            <div className="modalInnerCont">
              <AddCommitteeMemberModal />
            </div>
          </DialogContent>
        </Dialog>
      </div> */}
    </>
  );
}

export default AgenciesNewList;
